'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var paths = require('./paths.js');
var NarvarLogo_module = require('./NarvarLogo.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const NarvarLogo = _ref => {
  let {
    style = {}
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: (style === null || style === void 0 ? void 0 : style.color) ?? '#999'
    }
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: NarvarLogo_module["default"].narvarLogo,
    style: style,
    fill: "currentColor",
    viewBox: "0 0 153 24"
  }, /*#__PURE__*/React__default["default"].createElement("title", null, "Powered by Narvar"), /*#__PURE__*/React__default["default"].createElement("path", {
    d: paths.poweredByNarvarString
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: paths.isotype
  })));
};

exports["default"] = NarvarLogo;
